<template>
  <mdb-navbar expand="small" color="black" position="top" scrolling>
    <mdb-navbar-brand to="/#">
      <img class="logoimg" src="/static/images/logo/logowithtext3.png">
    </mdb-navbar-brand>
    <a class="phone" href="tel:02-566-3425">
      <mdb-btn class="phoneno btn-sm" color="black">
        <img src="/static/images/icons/phone-call.png"/>
      </mdb-btn>
      상담전화
    </a>
  </mdb-navbar>
</template>

<script>
export default {
  name: 'NavbarPage',
};
</script>

<style scoped>
.mbnavbar {
  max-width: 100% !important;
  padding: 0 0px;
  max-height: 75px;
  min-height: 43px;
}
.navbar {
  position: fixed;
  padding: 0rem 0rem !important;
  max-height: 65px;
  min-height: 43px;
}
.logoimg {
  max-width: 261px;
  max-height: 34.51px;
  margin-left: 7px;
}
.phone img{
  max-width: 30px;
  max-height: 25px;
  margin-right: 10px;
}
.phoneno{
  background-color:transparent;
  color:transparent;
  font-size: 14px;
  max-width: 50px;
  padding: 0 0px;
  margin: 0 0px;
}
.phone{
  color: white;
  font-size: 10px;
}
</style>
